export default __webpack_public_path__ + "static/media/exit.min.8d024704.svg";